// 어드민 API 호출 헬퍼 — X-Admin-Token 자동 부착 + 실패 시 서버 message 를 담은 AdminApiError
const ADMIN_TOKEN = (import.meta as unknown as { env: Record<string, string> }).env?.VITE_ADMIN_TOKEN ?? '';

export class AdminApiError extends Error {
  status: number;
  body?: unknown;
  constructor(path: string, status: number, body?: unknown) {
    const serverMsg = (body as { message?: unknown } | null | undefined)?.message;
    super(typeof serverMsg === 'string' && serverMsg ? serverMsg : `${path} → HTTP ${status}`);
    this.name = 'AdminApiError';
    this.status = status;
    this.body = body;
  }
}

async function assertOk(path: string, res: Response): Promise<void> {
  if (res.ok) return;
  let body: unknown;
  try { body = await res.json(); } catch { body = undefined; }
  throw new AdminApiError(path, res.status, body);
}

export async function adminGet<T>(path: string): Promise<T> {
  const res = await fetch(path, { headers: { 'X-Admin-Token': ADMIN_TOKEN } });
  await assertOk(path, res);
  return res.json() as Promise<T>;
}

export async function adminPost<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(path, {
    method: 'POST',
    headers: { 'X-Admin-Token': ADMIN_TOKEN, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  await assertOk(path, res);
  return res.json() as Promise<T>;
}

export async function adminPut<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(path, {
    method: 'PUT',
    headers: { 'X-Admin-Token': ADMIN_TOKEN, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  await assertOk(path, res);
  return res.json() as Promise<T>;
}

export async function adminDelete(path: string): Promise<void> {
  const res = await fetch(path, {
    method: 'DELETE',
    headers: { 'X-Admin-Token': ADMIN_TOKEN },
  });
  await assertOk(path, res);
}
